export default "__VITE_ASSET__9884d4fe__"